import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { placeholderImage } from '@grandvisionhq/utils';

const CardImage = (_param)=>{
    var { alt , src , backgroundColor , imageHref , className , style  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "alt",
        "src",
        "backgroundColor",
        "imageHref",
        "className",
        "style"
    ]);
    const image = /*#__PURE__*/ React.createElement("img", swcHelpers.extends({}, rest, {
        className: classnames('card-image', !imageHref ? className : undefined, {
            'card-image--placeholder': !src
        }),
        // Even though it's required, the src might be an empty string.
        src: src || placeholderImage.url,
        alt: alt || '',
        style: swcHelpers.objectSpread({
            backgroundColor
        }, style)
    }));
    return imageHref ? /*#__PURE__*/ React.createElement("a", {
        href: imageHref,
        className: classnames('card-image-anchor', className)
    }, image) : image;
};

export { CardImage as default };
//# sourceMappingURL=CardImage.js.map
